import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListSettingsRequest, ListSettingsResponse, SaveSettingsRequest, SaveSettingsResponse } from "../contracts";
import { baseQueryWithAuth } from "./api";

export const settingsApi = createApi({
    reducerPath: "settingsApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        listSettings: builder.query<ListSettingsResponse, ListSettingsRequest>({
            query: body => ({
                url: "settings/list",
                method: "POST",
                body
            })
        }),
        saveSettings: builder.mutation<SaveSettingsResponse, SaveSettingsRequest>({
            query: body => ({
                url: "settings/save",
                method: "POST",
                body
            })
        })
    })
});

export const { useListSettingsQuery, useLazyListSettingsQuery, useSaveSettingsMutation } = settingsApi;
